import {Button, Leads, Text, Trails, Typography} from '@gwc/main'
import {genericMemo} from '@yandex-delivery/utils'
import clsx from 'clsx'

import * as classes from './Button.classes'
import {getTypographyVars} from './Button.utils'
import {AllowedComponent, ButtonProps as Props} from './types'
import React from 'react'

function Buttonv2Base<C extends AllowedComponent = 'button'>(props: Props<C>, ref: React.Ref<unknown>) {
  const {
    'data-testid': dataTestId,
    Component,
    fullWidth,
    className,
    size = 'm',
    textVariant: textVariantProp,
    lead,
    leadType: Lead = Leads.Icon,
    trail,
    trailType: Trail = Trails.Icon,
    children,
    variant = 'default',
    onPress,
    ...buttonProps
  } = props
  const {variant: textVariant, thickness: textThickness} = getTypographyVars({size, variant})
  const buttonVariant = variant === 'error' ? 'ghost' : variant

  return (
    // @ts-expect-error Button из GWC ожидает только нативные теги, но по факту умеет обрабатывать функции
    <Button
      className={clsx(className, {
        [classes.fullWidth]: fullWidth,
        [classes.error]: variant === 'error',
      })}
      Component={Component || 'button'}
      size={size}
      variant={buttonVariant}
      {...buttonProps}
      onPress={onPress}
      data-testid={dataTestId}
      ref={ref}
    >
      {lead && <Lead>{lead}</Lead>}
      {typeof children === 'string' ? (
        <Text
          // @ts-expect-error хак, чтобы наследовать выравнивание кнопки, а не компонента Text (в основном по центру)
          align={false}
          alignItems="center"
          // @ts-expect-error хак, чтобы наследовать цвет текста кнопки, а не компонента Text
          color={false}
          size={size}
        >
          <Typography data-testid={`typography-${dataTestId}`} thickness={textThickness} variant={textVariant}>
            {children}
          </Typography>
        </Text>
      ) : (
        children
      )}
      {trail && <Trail>{trail}</Trail>}
    </Button>
  )
}

export const Buttonv2 = genericMemo(
  React.forwardRef(Buttonv2Base) as <C extends AllowedComponent = 'button'>(
    props: Props<C> & { ref?: React.Ref<unknown> }
  ) => React.ReactElement
)
Buttonv2.displayName = 'Buttonv2'
export default Buttonv2
